/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AddUsersToPooledOrgOperationStatus } from '../model/addUsersToPooledOrgOperationStatus';
// @ts-ignore
import { DeleteOAuthAppForPooledOrgOperationStatus } from '../model/deleteOAuthAppForPooledOrgOperationStatus';
// @ts-ignore
import { PooledOrgOAuthAppAccessToken } from '../model/pooledOrgOAuthAppAccessToken';
// @ts-ignore
import { PooledOrgOAuthAppInfo } from '../model/pooledOrgOAuthAppInfo';
// @ts-ignore
import { RemoveUsersFromPooledOrgOperationStatus } from '../model/removeUsersFromPooledOrgOperationStatus';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PooledOrgOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Add the Org Owner users from assigned VCF Org, as Org Admin
     * Add the Org Owner users from assigned VCF Org, as Org Admin
     * @param provider Resource Provider
     * @param pooledOrgId Organization identifier
     * @param cspTenantAuthToken Access token with org_owner role in given pooled Org.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addUsersToPooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<AddUsersToPooledOrgOperationStatus>;
    public addUsersToPooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AddUsersToPooledOrgOperationStatus>>;
    public addUsersToPooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AddUsersToPooledOrgOperationStatus>>;
    public addUsersToPooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling addUsersToPooledOrgOperator.');
        }
        if (pooledOrgId === null || pooledOrgId === undefined) {
            throw new Error('Required parameter pooledOrgId was null or undefined when calling addUsersToPooledOrgOperator.');
        }
        if (cspTenantAuthToken === null || cspTenantAuthToken === undefined) {
            throw new Error('Required parameter cspTenantAuthToken was null or undefined when calling addUsersToPooledOrgOperator.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (cspTenantAuthToken !== undefined && cspTenantAuthToken !== null) {
            localVarHeaders = localVarHeaders.set('csp-tenant-auth-token', String(cspTenantAuthToken));
        }

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/resources/org-pool/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "pooledOrgId", value: pooledOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/add-users`;
        return this.httpClient.request<AddUsersToPooledOrgOperationStatus>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Authorize the pooled Org
     * Authorize Pool Org by creating OAuth app
     * @param provider Resource Provider
     * @param pooledOrgId Organization identifier
     * @param tokenWithOrgOwnerRole 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public authorizePooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, tokenWithOrgOwnerRole: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<PooledOrgOAuthAppInfo>;
    public authorizePooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, tokenWithOrgOwnerRole: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PooledOrgOAuthAppInfo>>;
    public authorizePooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, tokenWithOrgOwnerRole: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PooledOrgOAuthAppInfo>>;
    public authorizePooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, tokenWithOrgOwnerRole: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling authorizePooledOrgOperator.');
        }
        if (pooledOrgId === null || pooledOrgId === undefined) {
            throw new Error('Required parameter pooledOrgId was null or undefined when calling authorizePooledOrgOperator.');
        }
        if (tokenWithOrgOwnerRole === null || tokenWithOrgOwnerRole === undefined) {
            throw new Error('Required parameter tokenWithOrgOwnerRole was null or undefined when calling authorizePooledOrgOperator.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (tokenWithOrgOwnerRole !== undefined && tokenWithOrgOwnerRole !== null) {
            localVarHeaders = localVarHeaders.set('token-with-org-owner-role', String(tokenWithOrgOwnerRole));
        }

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/resources/org-pool/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "pooledOrgId", value: pooledOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/authorize`;
        return this.httpClient.request<PooledOrgOAuthAppInfo>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete all OAuth apps owned by given pooled org.
     * Delete all OAuth apps owned by given pooled org.
     * @param provider Resource Provider
     * @param pooledOrgId Organization identifier
     * @param cspTenantAuthToken Access token with org_owner role in given pooled Org.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOwnedOAuthAppsOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DeleteOAuthAppForPooledOrgOperationStatus>;
    public deleteOwnedOAuthAppsOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DeleteOAuthAppForPooledOrgOperationStatus>>;
    public deleteOwnedOAuthAppsOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DeleteOAuthAppForPooledOrgOperationStatus>>;
    public deleteOwnedOAuthAppsOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling deleteOwnedOAuthAppsOperator.');
        }
        if (pooledOrgId === null || pooledOrgId === undefined) {
            throw new Error('Required parameter pooledOrgId was null or undefined when calling deleteOwnedOAuthAppsOperator.');
        }
        if (cspTenantAuthToken === null || cspTenantAuthToken === undefined) {
            throw new Error('Required parameter cspTenantAuthToken was null or undefined when calling deleteOwnedOAuthAppsOperator.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (cspTenantAuthToken !== undefined && cspTenantAuthToken !== null) {
            localVarHeaders = localVarHeaders.set('csp-tenant-auth-token', String(cspTenantAuthToken));
        }

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/resources/org-pool/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "pooledOrgId", value: pooledOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/oauth-apps/owned`;
        return this.httpClient.request<DeleteOAuthAppForPooledOrgOperationStatus>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete all roles assigned OAuth apps for given pooled org.
     * Delete all roles assigned OAuth apps for given pooled org.
     * @param provider Resource Provider
     * @param pooledOrgId Organization identifier
     * @param cspTenantAuthToken Access token with org_owner role in given pooled Org.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRoleAssignedOAuthAppsOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DeleteOAuthAppForPooledOrgOperationStatus>;
    public deleteRoleAssignedOAuthAppsOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DeleteOAuthAppForPooledOrgOperationStatus>>;
    public deleteRoleAssignedOAuthAppsOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DeleteOAuthAppForPooledOrgOperationStatus>>;
    public deleteRoleAssignedOAuthAppsOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling deleteRoleAssignedOAuthAppsOperator.');
        }
        if (pooledOrgId === null || pooledOrgId === undefined) {
            throw new Error('Required parameter pooledOrgId was null or undefined when calling deleteRoleAssignedOAuthAppsOperator.');
        }
        if (cspTenantAuthToken === null || cspTenantAuthToken === undefined) {
            throw new Error('Required parameter cspTenantAuthToken was null or undefined when calling deleteRoleAssignedOAuthAppsOperator.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (cspTenantAuthToken !== undefined && cspTenantAuthToken !== null) {
            localVarHeaders = localVarHeaders.set('csp-tenant-auth-token', String(cspTenantAuthToken));
        }

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/resources/org-pool/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "pooledOrgId", value: pooledOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/oauth-apps/assigned`;
        return this.httpClient.request<DeleteOAuthAppForPooledOrgOperationStatus>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates access token for the provided pooled Org.
     * Generates access token for the provided pooled Org.
     * @param pooledOrgId Organization identifier
     * @param provider Resource Provider
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generatePooledOrgOAuthAppAccessTokenOperator(pooledOrgId: string, provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<PooledOrgOAuthAppAccessToken>;
    public generatePooledOrgOAuthAppAccessTokenOperator(pooledOrgId: string, provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PooledOrgOAuthAppAccessToken>>;
    public generatePooledOrgOAuthAppAccessTokenOperator(pooledOrgId: string, provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PooledOrgOAuthAppAccessToken>>;
    public generatePooledOrgOAuthAppAccessTokenOperator(pooledOrgId: string, provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (pooledOrgId === null || pooledOrgId === undefined) {
            throw new Error('Required parameter pooledOrgId was null or undefined when calling generatePooledOrgOAuthAppAccessTokenOperator.');
        }
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling generatePooledOrgOAuthAppAccessTokenOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/resources/org-pool/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "pooledOrgId", value: pooledOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/generate-access-token`;
        return this.httpClient.request<PooledOrgOAuthAppAccessToken>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove all users from the pooled org except Org owners.
     * Remove all users from the pooled org except Org owners.
     * @param provider Resource Provider
     * @param pooledOrgId Organization identifier
     * @param cspTenantAuthToken Access token with org_owner role in given pooled org.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeUsersFromPooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RemoveUsersFromPooledOrgOperationStatus>;
    public removeUsersFromPooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RemoveUsersFromPooledOrgOperationStatus>>;
    public removeUsersFromPooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RemoveUsersFromPooledOrgOperationStatus>>;
    public removeUsersFromPooledOrgOperator(provider: 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS', pooledOrgId: string, cspTenantAuthToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling removeUsersFromPooledOrgOperator.');
        }
        if (pooledOrgId === null || pooledOrgId === undefined) {
            throw new Error('Required parameter pooledOrgId was null or undefined when calling removeUsersFromPooledOrgOperator.');
        }
        if (cspTenantAuthToken === null || cspTenantAuthToken === undefined) {
            throw new Error('Required parameter cspTenantAuthToken was null or undefined when calling removeUsersFromPooledOrgOperator.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (cspTenantAuthToken !== undefined && cspTenantAuthToken !== null) {
            localVarHeaders = localVarHeaders.set('csp-tenant-auth-token', String(cspTenantAuthToken));
        }

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/resources/org-pool/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "pooledOrgId", value: pooledOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/remove-users`;
        return this.httpClient.request<RemoveUsersFromPooledOrgOperationStatus>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
